import { render, staticRenderFns } from "./NuevaCita.vue?vue&type=template&id=4f7b8863&"
import script from "./NuevaCita.vue?vue&type=script&lang=js&"
export * from "./NuevaCita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports